import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './Pages/Home';
import TeamSetup from './Pages/TeamSetup';
import Register from './Pages/Register';
import Admin from './Pages/Admin';
import { ThemeProvider } from './context/ThemeContext';
import './App.css';
import GameSession from './Pages/GameSession';
import Question from './Pages/Question';
import Layout from './components/Layout';
import FinalScore from './Pages/FinalScore';
import BuySessionsPage from './Pages/BuySessions'
import Terms from './Pages/Terms';
import Privacy from './Pages/Privacy';

const App: React.FC = () => {
  return (
    <ThemeProvider>
      <div className="App">
        <Router>
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/team-setup" element={<TeamSetup />} />
              <Route path="/register" element={<Register />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/game/:sessionId" element={<GameSession />} />
              <Route path="/question/:questionId" element={<Question />} />
              <Route path="/final-score/:sessionId" element={<FinalScore />} />
              <Route path="/buy-sessions" element={<BuySessionsPage />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/privacy" element={<Privacy />} />
            </Routes>
          </Layout>
        </Router>
      </div>
    </ThemeProvider>
  );
};

export default App;
